import React from "react"

function Footer(){
    return(<footer>
        © 2021 by DreamCraft
    </footer>)
}

export default Footer